var ec = (function (exports) {
    'use strict';

    class Logger {
        constructor(enabled) {
            this.enabled = enabled;
        }
        log(message) {
            !this.enabled ? null : console.log(`[ec] ${message}`);
        }
        info(message) {
            !this.enabled ? null : console.log(`[ec] %c ${message}`, 'color: gray');
        }
        warn(message) {
            !this.enabled ? null : console.log(`[ec] %c ${message}`, 'color: #a3a300');
        }
        error(message) {
            !this.enabled ? null : console.log(`[ec] %c ${message}`, 'color: red');
        }
    }

    class GTMService {
        constructor(dataLayer, parent) {
            this.dataLayer = dataLayer;
            this.parent = parent;
            this.debug = new Logger(this.parent.config.debug);
            if (!this.dataLayer) {
                this.debug.info('init empty dataLayer');
                this.dataLayer = window.dataLayer ? window.dataLayer : [];
            }
        }
        push(data) {
            this.dataLayer.push({ 'ecommerce': null });
            this.dataLayer.push(data);
        }

        trackProductViews(ecDatas) {
            let impressions = [];
            ecDatas.forEach(ecData => {
                impressions.push({
                    'id': ecData.id,
                    'name': ecData.name,
                    'price': ecData.price,
                    'brand': ecData.brand,
                    'category': ecData.category,
                    'variant': ecData.variant,
                    'list': ecData.list,
                    'position': ecData.position
                });
            });
            return this.push({
                'ecommerce': {
                    'currencyCode': this.parent.config.currencyCode,
                    'impressions': impressions
                }
            });
        }
        trackProductView(ecData) {
            return this.push({
                'ecommerce': {
                    'currencyCode': ecData.currency ? ecData.currency : this.parent.config.currencyCode,
                    'impressions': [{
                        'id': ecData.id,
                        'name': ecData.name,
                        'price': ecData.price,
                        'brand': ecData.brand,
                        'category': ecData.category,
                        'variant': ecData.variant,
                        'list': ecData.list,
                        'position': ecData.position
                    }]
                }
            });
        }
        followProduct(ecData) {
            var pushData = {
                'event': 'productClick',
                'ecommerce': {
                    'click': {
                        'actionField': { 'list': ecData.list },
                        'products': [{
                            'id': ecData.id,
                            'name': ecData.name,
                            'price': ecData.price,
                            'brand': ecData.brand,
                            'category': ecData.category,
                            'variant': ecData.variant,
                            'list': ecData.list,
                            'position': ecData.position
                        }]
                    }
                }
            };
            if (ecData.url) {
                pushData.eventCallback = function () {
                    document.location = ecData.url;
                };
            }
            return this.push(pushData);
        }
        trackProductDetail(ecData) {
            return this.push({
                'event': 'productView',
                'ecommerce': {
                    'detail': {
                        'actionField': ecData.list ? { 'list': ecData.list } : {},
                        'products': [{
                            'id': ecData.id,
                            'name': ecData.name,
                            'price': ecData.price,
                            'brand': ecData.brand,
                            'category': ecData.category,
                            'variant': ecData.variant
                        }]
                    }
                }
            });
        }
        addCartProduct(ecData) {
            var pushData = {
                'event': 'addToCart',
                'ecommerce': {
                    'currencyCode': ecData.currency ? ecData.currency : this.parent.config.currencyCode,
                    'add': {
                        'actionField': { 'list': ecData.list },
                        'products': [{
                            'id': ecData.id,
                            'name': ecData.name,
                            'price': ecData.price,
                            'brand': ecData.brand,
                            'category': ecData.category,
                            'variant': ecData.variant,
                            'quantity': ecData.quantity,
                            'position': ecData.position
                        }]
                    }
                }
            };
            return this.push(pushData);
        }
        removeCartProduct(ecData) {
            var productData = {
                'id': ecData.id,
                'quantity': ecData.quantity
            };
            if (ecData.name) {
                productData.name = ecData.name;
            }
            if (ecData.price) {
                productData.price = ecData.price;
            }
            if (ecData.brand) {
                productData.brand = ecData.brand;
            }
            if (ecData.category) {
                productData.category = ecData.category;
            }
            if (ecData.variant) {
                productData.variant = ecData.variant;
            }
            if (ecData.position) {
                productData.position = ecData.position;
            }
            var pushData = {
                'event': 'removeFromCart',
                'ecommerce': {
                    'currencyCode': ecData.currency ? ecData.currency : this.parent.config.currencyCode,
                    'remove': {
                        'actionField': { 'list': ecData.list },
                        'products': [productData]
                    }
                }
            };
            return this.push(pushData);
        }
        steps(step, option, products) {
            var pushData = {
                'event': 'checkout',
                'currencyCode': this.parent.config.currencyCode,
                'ecommerce': {
                    'checkout': {
                        'actionField': !option ? { 'step': step } : { 'step': step, 'option': option },
                        'products': products
                    }
                }
            };
            return this.push(pushData);
        }
        purchase(actionField, products) {
            var pushData = {
                'event': 'purchase',
                'ecommerce': {
                    'currencyCode': this.parent.config.currencyCode,
                    'purchase': {
                        'actionField': actionField,
                        'products': products
                    }
                }
            };
            return this.push(pushData);
        }
    }

    class EnhancedEcommerceService {
        constructor(config) {
            this.config = config;
            this.ecAttrsRequired = {
                'id': true,
                'name': true,
                'price': true
            };
            this.ecAttrsLookup = {
                'list': true,
                'category': true,
                'brand': true
            };
            this.ecAttrsSkip = {
                'action': true
            };
            this.ecAttrsAllowed = {
                'id': true,
                'name': true,
                'brand': true,
                'price': true,
                'position': true,
                'category': true,
                'variant': true,
                'list': true,
                'currency': true,
                'url': true
            };
            this.gtm = new GTMService(config.dataLayer, this);
            this.debug = new Logger(config.debug);
            if (this.config.prefix === undefined) {
                this.config.prefix = 'data-ec';
            }
            if (this.config.currencyCode === undefined) {
                this.config.currencyCode = 'EUR';
            }
        }
        init() {
            this.selectedNodes = document.querySelectorAll("*[" + this.config.prefix + "-action]");
            var impressions = [];
            var self = this;
            for (var i = 0; i < this.selectedNodes.length; i++) {
                var node = this.selectedNodes[i];
                var actions = node.getAttribute(this.config.prefix + '-action').split(',');
                actions.map(action => {
                    action = action.trim();
                    switch (action) {
                        case 'view':
                            this.debug.log('run view');
                            let ecData = this.getData(node);
                            if (ecData.id) {
                                impressions.push(ecData);
                            }
                            break;
                        case 'follow':
                            this.debug.log('apply follow');
                            node.addEventListener('click', event => {
                                let ecData = self.getData(event.srcElement);
                                if (ecData.url) {
                                    event.preventDefault();
                                }
                                this.gtm.followProduct(ecData);
                            });
                            break;
                        case 'detail':
                            this.debug.log('apply detail');
                            let ecDataDetail = this.getData(node);
                            this.debug.log(JSON.stringify(ecDataDetail, null, '\t'));
                            this.gtm.trackProductDetail(ecDataDetail);
                            break;
                        case 'purchase':
                            this.debug.log('apply purchase');
                            let purchaseData = {};
                            let purchaseProducts = JSON.parse(document.querySelector("*[" + this.config.prefix + "-products]").getAttribute(this.config.prefix + '-products'));
                            let ecId = document.querySelector("*[" + this.config.prefix + "-purchase-id]").getAttribute(this.config.prefix + '-purchase-id');
                            let ecAffiliation = document.querySelector("*[" + this.config.prefix + "-purchase-affiliation]").getAttribute(this.config.prefix + '-purchase-affiliation');
                            let ecTax = document.querySelector("*[" + this.config.prefix + "-purchase-tax]").getAttribute(this.config.prefix + '-purchase-tax');
                            let ecShipping = document.querySelector("*[" + this.config.prefix + "-purchase-shipping]").getAttribute(this.config.prefix + '-purchase-shipping');
                            let ecRevenue = document.querySelector("*[" + this.config.prefix + "-purchase-revenue]").getAttribute(this.config.prefix + '-purchase-revenue');
                            purchaseData.id = ecId;
                            purchaseData.affiliation = ecAffiliation;
                            purchaseData.tax = parseFloat(ecTax).toFixed(2);
                            purchaseData.shipping = parseFloat(ecShipping).toFixed(2);
                            purchaseData.revenue = parseFloat(ecRevenue).toFixed(2);
                            this.debug.log('apply purchase with actionField:');
                            this.debug.log(JSON.stringify(purchaseData, null, '\t'));
                            this.debug.log('apply purchase with products:');
                            this.debug.log(JSON.stringify(purchaseProducts, null, '\t'));
                            this.gtm.purchase(purchaseData, purchaseProducts);
                            break;
                        case 'step':
                            let step = parseInt(document.querySelector("*[" + this.config.prefix + "-step]").getAttribute(this.config.prefix + '-step'));
                            let stepProducts = JSON.parse(document.querySelector("*[" + this.config.prefix + "-step]").getAttribute(this.config.prefix + '-products'));
                            this.debug.log('apply step ' + step + ' with products:');
                            this.debug.log(JSON.stringify(stepProducts, null, '\t'));
                            this.gtm.steps(step, '', stepProducts);
                            break;
                    }
                });
            }
            if (impressions.length) {
                this.gtm.trackProductViews(impressions);
            }
            this.debug.warn('initialized on ' + this.selectedNodes.length + ' nodes');
            if (document.getElementsByClassName(`${this.config.prefix}-track-cart-step`)[0]) {
                let mainNode;
                document.getElementsByClassName(`${this.config.prefix}-track-cart-step`)[0].addEventListener('click', e => {
                    mainNode = e.target;
                    let optionsArr = [];
                    let stepProducts = JSON.parse(document.querySelector("*[" + this.config.prefix + "-products]").getAttribute(this.config.prefix + '-products'));
                    let step = parseInt(mainNode.getAttribute(this.config.prefix + '-step'));
                    this.debug.log('apply step ' + step + ' with products:');
                    this.debug.log(JSON.stringify(stepProducts, null, '\t'));
                    let options = document.querySelectorAll("*[" + this.config.prefix + "-option]");
                    if (options) {
                        options.forEach(option => {
                            let optionChecked = option;
                            if (optionChecked.checked) {
                                optionsArr.push(optionChecked.value);
                            }
                        });
                        if (optionsArr.length) {
                            this.debug.log('options: ' + optionsArr.join(' / '));
                        }
                    }
                    this.gtm.steps(step, optionsArr ? optionsArr.join(' / ') : '', stepProducts);
                });
            }
        }
        responseInit(appendLimit) {
            this.selectedNodes = document.querySelectorAll(`.${this.config.prefix}-item-response[${this.config.prefix}-action]`);
            var impressions = [];
            this.selectedNodes.forEach((item, index) => {
                if (index + 1 >= appendLimit) {
                    var node = item;
                    var actions = node.getAttribute(this.config.prefix + '-action').split(',');
                    var itemsId = node.getAttribute(this.config.prefix + '-id');
                    actions.filter((action, index) => {
                        action = action.trim();
                        if (action == 'view') {
                            this.debug.log('run view on AJAX success - item ID: ' + itemsId);
                            let ecData = this.getData(node);
                            if (ecData.id) {
                                impressions.push(ecData);
                            }
                        }
                    });
                }
            });
            if (impressions) {
                this.gtm.trackProductViews(impressions);
            }
        }
        getData(node) {
            let ecData = {};
            let mainNode;
            mainNode = node.closest('*[' + this.config.prefix + '-id]');
            if (!mainNode) {
                this.debug.log('cant find closest node with filled product id');
                return ecData;
            }
            for (var i = 0, n = mainNode.attributes.length; i < n; i++) {
                let nodeName = mainNode.attributes[i].nodeName;
                if (nodeName.match('^' + this.config.prefix)) {
                    nodeName = nodeName.replace(this.config.prefix + '-', "");
                    if (this.ecAttrsSkip[nodeName]) {
                        continue;
                    }
                    if (!this.ecAttrsAllowed[nodeName]) {
                        this.debug.log('not supported attr name ' + this.config.prefix + '-' + nodeName);
                    }
                    ecData[nodeName] = mainNode.attributes[i].nodeValue;
                }
            }
            Object.keys(this.ecAttrsLookup).forEach(key => {
                if (!ecData[key]) {
                    let attrNode = node.closest('*[' + this.config.prefix + '-' + key + ']');
                    if (attrNode) {
                        ecData[key] = attrNode.getAttribute(this.config.prefix + '-' + key);
                    }
                }
            });
            Object.keys(this.ecAttrsRequired).forEach(key => {
                if (!ecData[key]) {
                    this.debug.warn("can't find not null attr name " + this.config.prefix + '-' + key);
                }
            });
            if (ecData['list'] && !ecData['position']) {
                ecData['position'] = 1;
                let sibNode = mainNode;
                if (sibNode.closest(`[${this.config.prefix}-position]`)) {
                    ecData['position'] = sibNode.closest(`[${this.config.prefix}-position]`).getAttribute(this.config.prefix + '-position');
                } else {
                    while (sibNode = sibNode.previousElementSibling) {
                        ecData['position']++;
                    }
                }
            }
            return ecData;
        }
        follow(node) {
            this.debug.info('track follow()');
            let ecData = this.getData(node);
            if (ecData.url) {
                event.preventDefault();
            }
            this.gtm.followProduct(ecData);
        }
        addCart(node, config) {
            this.debug.info('track addCart()');
            let nodeData = this.getData(node);
            let ecData = Object.assign({}, nodeData, config);
            this.debug.log(JSON.stringify(ecData, null, '\t'));
            this.gtm.addCartProduct(ecData);
        }
        removeCart(node, config) {
            this.debug.info('track removeCart()');
            let nodeData;
            let ecData;
            if (typeof node === "object" && node.nodeType === 1) {
                nodeData = this.getData(node);
                ecData = Object.assign({}, nodeData, config);
            } else {
                ecData = node;
            }
            this.debug.log(JSON.stringify(ecData, null, '\t'));
            this.gtm.removeCartProduct(ecData);
        }
        steps(step, optionsArr = [], stepProducts) {
            if (!stepProducts) {
                stepProducts = JSON.parse(document.querySelector("*[" + this.config.prefix + "-step]").getAttribute(this.config.prefix + '-products'));
            }
            if (optionsArr.length) {
                this.debug.log('options: ' + optionsArr.join(' / '));
            }
            this.debug.log('apply step ' + step + ' with products:');
            this.debug.log(JSON.stringify(stepProducts, null, '\t'));
            this.gtm.steps(step, optionsArr ? optionsArr.join(' / ') : '', stepProducts);
        }
        purchase(actionField, products) {
            this.debug.log('apply purchase with actionField:');
            this.debug.log(JSON.stringify(actionField, null, '\t'));
            this.debug.log('apply purchase with products:');
            this.debug.log(JSON.stringify(products, null, '\t'));
            this.gtm.purchase(actionField, products);
        }
    }

    function init(config) {
        let ecService = new EnhancedEcommerceService(config);
        ecService.init();
        return ecService;
    }

    exports.init = init;

    return exports;

}({}));
//# sourceMappingURL=ec-plugin-bundle.js.map
